import { styled } from '@mui/material/styles';
import { Box, Paper, LinearProgress } from '@mui/material';

export const UploadCardWrapper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    elevation: 0,
    }));

export const FileIconWrapper = styled(Box)(({ theme }) => ({
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
}));

export const FileInfoWrapper = styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
}));

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    marginTop: theme.spacing(0.5),
    height: 4,
    borderRadius: 5,
}));
